import React from 'react';

import CheckIcon from '@mui/icons-material/Check';
import { Box, Button, Chip, Stack, TableCell, TableRow } from '@mui/material';

import { formatMoney } from '../../shared/checklistUtils';

import type { DealOptionsInclusionsChecklistRow } from './types';

interface Props {
  approved: boolean;
  currency: string;
  inc: DealOptionsInclusionsChecklistRow;
  manuallyApproved: boolean;
  onApprovalChange: (rowId: string) => void;
  onUnapprovalChange: (rowId: string) => void;
}

export default function InclusionRow({
  approved,
  currency,
  inc,
  manuallyApproved,
  onApprovalChange,
  onUnapprovalChange,
}: Props) {
  const dotColor = approved ? 'success.main' : 'warning.main';

  return (
    <TableRow hover>
      <TableCell sx={{ overflowWrap: 'break-word' }}>{inc.name || '—'}</TableCell>
      <TableCell sx={{ overflowWrap: 'break-word' }}>{inc.description || '—'}</TableCell>
      <TableCell>{inc.type || '—'}</TableCell>
      <TableCell>{formatMoney(inc.dealOptionInclusionRrp, currency)}</TableCell>
      <TableCell>{formatMoney(inc.inclusionAssetValue, currency)}</TableCell>
      <TableCell>{formatMoney(inc.totalValue, currency)}</TableCell>
      <TableCell>
        <Stack direction="row" spacing={0.75} alignItems="center">
          <Box
            component="span"
            sx={{
              bgcolor: dotColor,
              borderRadius: '50%',
              boxShadow: '0 0 0 2px rgba(0,0,0,0.04)',
              display: 'inline-block',
              flexShrink: 0,
              height: 10,
              width: 10,
            }}
          />
          {manuallyApproved && (
            <Chip label="Manual" size="small" color="success" variant="outlined" sx={{ height: 20, fontSize: 11 }} />
          )}
        </Stack>
      </TableCell>
      <TableCell>
        {approved ? (
          <Button size="small" variant="outlined" color="error" onClick={() => onUnapprovalChange(inc.id)}>
            Unapprove
          </Button>
        ) : inc.status !== 'blocked' ? (
          <Button size="small" variant="contained" startIcon={<CheckIcon />} onClick={() => onApprovalChange(inc.id)}>
            Approve
          </Button>
        ) : null}
      </TableCell>
    </TableRow>
  );
}
